module.exports = __webpack_public_path__ + "img/hdl.6079da90.png";